import { graphql, useStaticQuery } from 'gatsby';

const UseEvents = () => {
  const data = useStaticQuery(graphql`
    query FAQPageQuery {
      allMedcoeEventAncmtJson(filter: { Portlet_ID: { eq: 22 } }) {
        nodes {
          PublicEvent_ID
          Event
          Description
        }
      }
    }
  `);

  return data.allMedcoeEventAncmtJson.nodes.map(event => ({
    id: event.PublicEvent_ID,
    question: event.Event,
    answer: event.Description
  }));
};

export default UseEvents;
